import { Text, HStack } from '@genial/components';
import { BoxRadius, Spacing, Typography } from '@genial/design-tokens';
import { IPressableProps, IStackProps, Pressable } from 'native-base';
import React from 'react';

interface TableHeadContainerProps extends IStackProps {
  children: React.ReactNode;
}

export interface TableHeadItemRecurse {
  title: string;
  flex?: number;
}

interface TableHeadItemProps extends IPressableProps {
  title?: string;
  children?: React.ReactNode;
}

export const TableHeadItem: React.FC<TableHeadItemProps> = ({
  title,
  children,
  onPress,
  flex = 1,
  ...rest
}) => {
  return (
    <Pressable p={0} variant="unstyled" onPress={onPress} flex={flex} bg={rest.bg}>
      <HStack space={Spacing['inline.quarck']}>
        {children ?? (
          <Text
            variant="semibold"
            noOfLines={1}
            color="neutral.darkest"
            fontSize={Typography['fontsize.md']}>
            {title}
          </Text>
        )}
      </HStack>
    </Pressable>
  );
};

export const TableHeadContainer: React.FC<TableHeadContainerProps> = ({ children, ...rest }) => {
  return (
    <HStack
      display={{ base: 'none', lg: 'flex' }}
      alignItems="center"
      justifyContent="space-between"
      bg="brand.tertiary.lightest"
      px={Spacing['inline.xxs']}
      py={Spacing['inline.nano']}
      borderRadius={BoxRadius.sm}
      w="full"
      {...rest}>
      {children}
    </HStack>
  );
};
